/* ===================================================================
   collection-filters.js
   Katalogin filtterit — TÄYSIN AJAX, event-delegaatiolla.
   Delegaatio = kuuntelijat kiinnitetään kerran document/root-tasolle,
   joten ne selviävät kaikista innerHTML-vaihdoista ilman uudelleensidontaa.
   - checkbox/radio → heti AJAX
   - hintakenttä: Enter TAI Käytä-nappi → AJAX (EI sivun reloadia)
   - lajittelu, aktiivisten X-linkit, Tyhjennä → AJAX
   - mobiilidrawer: avaa/sulje
   - Lataa lisää: liittää seuraavan sivun (säilyttää filtterit)
   Osittainen päivitys Section Rendering APIlla (?section_id=), URL pushState.
   =================================================================== */
(function(){
  var root = document.querySelector('[data-collection-root]');
  if(!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var gridSel   = '[data-collection-results]';
  var busy = false;

  /* ---------- Osittainen päivitys ---------- */
  function fetchAndSwap(url, push){
    if(busy) return;
    busy = true;
    var results = root.querySelector(gridSel);
    if(results) results.setAttribute('aria-busy', 'true');

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function(r){ if(!r.ok) throw new Error('bad'); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var swaps = ['[data-collection-results]','[data-desktop-filters]','[data-active-filters]','[data-collection-count]','[data-drawer-filters]'];
        swaps.forEach(function(sel){
          // desktop-filtterit ja drawer-filtterit ovat eri paikoissa; hae molemmat dokista+sivulta
          var oldEls = document.querySelectorAll(sel);
          var newEl = doc.querySelector(sel);
          if(newEl){
            oldEls.forEach(function(oldEl){ oldEl.innerHTML = newEl.innerHTML; });
          }
        });
        if(push){ history.pushState({ skelteCollection:true }, '', url); }
        var res = root.querySelector(gridSel);
        if(res) res.removeAttribute('aria-busy');
        busy = false;
        var top = root.getBoundingClientRect().top;
        if(top < -80) root.scrollIntoView({ behavior:'smooth', block:'start' });
      })
      .catch(function(){
        busy = false;
        window.location.href = url;   // fallback: kova navigointi
      });
  }

  /* ---------- Lomake → URL ---------- */
  function formToUrl(form){
    var params = new URLSearchParams(new FormData(form));
    var cleaned = new URLSearchParams();
    params.forEach(function(v, k){ if(v !== '' && v != null) cleaned.append(k, v); });
    var base = form.getAttribute('action') || window.location.pathname;
    var qs = cleaned.toString();
    return base + (qs ? '?' + qs : '');
  }

  /* ===== DELEGAATIO (document-taso — kattaa sekä sivupalkin että drawerin) ===== */

  // checkbox/radio muutos → heti AJAX
  document.addEventListener('change', function(e){
    var t = e.target;
    if(t && t.matches && t.matches('[data-filter-input]')){
      var form = t.closest('[data-filter-form]');
      if(form){ fetchAndSwap(formToUrl(form), true); }
    }
  });

  // lomakkeen submit (hintakenttä Enter TAI Käytä-nappi) → AJAX, ei reloadia
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(form && form.matches && form.matches('[data-filter-form]')){
      e.preventDefault();
      fetchAndSwap(formToUrl(form), true);
    }
  });

  // Enter hintakentässä: varmista ettei natiivi submit pääse läpi ennen käsittelyä
  document.addEventListener('keydown', function(e){
    if(e.key === 'Enter'){
      var t = e.target;
      if(t && t.matches && t.matches('[data-price-input]')){
        e.preventDefault();
        var form = t.closest('[data-filter-form]');
        if(form){ fetchAndSwap(formToUrl(form), true); }
      }
    }
  });

  // klikkaukset: aktiivisten X-linkit, Tyhjennä, drawer auki/kiinni
  document.addEventListener('click', function(e){
    // AJAX-linkit (aktiiviset filtterit, tyhjennä kaikki)
    var rm = e.target.closest ? e.target.closest('[data-filter-remove]') : null;
    if(rm){
      e.preventDefault();
      fetchAndSwap(rm.getAttribute('href'), true);
      return;
    }
    // drawer auki
    var openBtn = e.target.closest ? e.target.closest('[data-cf-open]') : null;
    if(openBtn){ openDrawer(); return; }
    // drawer kiinni
    var closeBtn = e.target.closest ? e.target.closest('[data-cf-close]') : null;
    if(closeBtn){ closeDrawer(); return; }
    // Lataa lisää
    var more = e.target.closest ? e.target.closest('[data-load-more]') : null;
    if(more){ e.preventDefault(); loadMore(more); return; }
  });

  // lajittelu (delegoitu change kattaa senkin, mutta erillinen koska muuttaa sort_by:n)
  document.addEventListener('change', function(e){
    var sel = e.target;
    if(sel && sel.matches && sel.matches('[data-sort-select]')){
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      fetchAndSwap(u.pathname + u.search, true);
    }
  });

  /* ---------- Drawer ---------- */
  function drawerEl(){ return document.querySelector('[data-cf-drawer]'); }
  function openDrawer(){
    var d = drawerEl(); if(!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    d.setAttribute('aria-hidden','false');
  }
  function closeDrawer(){
    var d = drawerEl(); if(!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    d.setAttribute('aria-hidden','true');
  }
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      var d = document.querySelector('[data-cf-drawer].is-open');
      if(d) closeDrawer();
    }
  });

  /* ---------- Lataa lisää ---------- */
  function loadMore(btn){
    var grid = root.querySelector('[data-product-grid]');
    if(!grid) return;
    var url = btn.getAttribute('data-next-url');
    if(!url || btn.disabled) return;
    var LOADING = btn.getAttribute('data-loading') || 'Ladataan…';
    var LABEL = btn.textContent.trim();
    btn.disabled = true; btn.textContent = LOADING;
    fetch(url)
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html,'text/html');
        doc.querySelectorAll('[data-product-grid] > li').forEach(function(li){ grid.appendChild(li); });
        var nb = doc.querySelector('[data-load-more]');
        if(nb){ btn.setAttribute('data-next-url', nb.getAttribute('data-next-url')); btn.disabled=false; btn.textContent=LABEL; }
        else if(btn.parentNode){ btn.parentNode.removeChild(btn); }
      })
      .catch(function(){ btn.disabled=false; btn.textContent=LABEL; });
  }

  // Back/forward
  window.addEventListener('popstate', function(){
    fetchAndSwap(window.location.pathname + window.location.search, false);
  });
})();